import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AudioToText {

  public isRecording = new BehaviorSubject<boolean>(false);
  public isProcessing = new BehaviorSubject<boolean>(false);
  public volumeScalePercentage = 0;
  public textReceived = new Subject<string>();

  private mediaRecorder!: MediaRecorder;
  private chunks: Blob[] = [];
  private animationFrameId: number = -1;
  private volumeScale = 1;
  private dataArray: Uint8Array<ArrayBuffer> = new Uint8Array(2048);
  private analyser!: AnalyserNode;
  private audioCtx!: AudioContext;

  constructor(private http: HttpClient) {
  }

  public startRecording() {
    navigator.mediaDevices.getUserMedia({ audio: true }).then(stream => {
      this.audioCtx = new (window.AudioContext || (window as any).webkitAudioContext)();
      const source = this.audioCtx.createMediaStreamSource(stream);
      this.analyser = this.audioCtx.createAnalyser();
      this.analyser.fftSize = 2048;
      this.dataArray = new Uint8Array(this.analyser.fftSize);
      source.connect(this.analyser);

      this.chunks = [];
      this.mediaRecorder = new MediaRecorder(stream);
      this.mediaRecorder.ondataavailable = (e) => {
        this.chunks.push(e.data);
      };
      this.mediaRecorder.onstop = () => {
        if (this.chunks.length > 1) {
          const blob = new Blob(this.chunks, { type: 'audio/webm' });
          this.chunks = [];
          this.isProcessing.next(true);
          this.getTextFromSpeech(blob).then(d => {
            this.textReceived.next(d.text);
          }).finally(() => {
            this.isProcessing.next(false);
          });
        }
        this.audioCtx.close();
        source.disconnect();
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = -1;
        stream.getTracks().forEach(track => track.stop());
        this.isRecording.next(false);
      };
      this.mediaRecorder.start(500);
      this.isRecording.next(true);
      if (this.animationFrameId == -1) {
        this.onNextFrame();
      }
    }).catch((err: unknown) => {
      alert("Beim verwenden Ihres Mikrofons ist ein Fehler aufgetreten.");
      console.error('Mic permission error:', err);
    });
  }

  public stopRecording() {
    if (this.isRecording.value) {
      this.mediaRecorder.stop();
    }
  }

  private async getTextFromSpeech(blob: Blob): Promise<{ text: string }> {
    const formData = new FormData();
    formData.append('file', blob, "none.mp3");
    return await firstValueFrom(this.http.post<{ text: string }>("/api/interact/audiototext", formData));
  }

  private onNextFrame = () => {
    this.animationFrameId = requestAnimationFrame(this.onNextFrame);

    this.analyser.getByteTimeDomainData(this.dataArray);
    let sum = 0;
    for (const check of this.dataArray) {
      const val = (check - 128) / 128;
      sum += val * val;
    }
    const rootMeanSquare = Math.sqrt(sum / this.dataArray.length);
    const clampedRMS = Math.min(rootMeanSquare, 0.2); // Begrenze Maximalwert
    this.volumeScale = 1 + clampedRMS * 5; // Skaliere visuell, z.B. 1.0 bis 2.0
    const maxVolumeScale = 2.0;
    this.volumeScale = Math.min(this.volumeScale, maxVolumeScale);
    this.volumeScalePercentage = ((this.volumeScale - 1) / (maxVolumeScale - 1)) * 100;
    console.log(this.volumeScalePercentage)
  }

}
